module.exports = __webpack_public_path__ + "img/tod-large.8fcdb911.jpg";